'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/** Currently supported key for group by operation. */
var GroupByKey = /*#__PURE__*/function (GroupByKey) {
  GroupByKey["Who"] = "who";
  GroupByKey["What"] = "what";
  GroupByKey["Where"] = "where";
  return GroupByKey;
}({});

exports.GroupByKey = GroupByKey;
